import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import Classes from "model";

import ParticipantsACHPage, { getDefaultUI } from "components/pages/ParticipantsACHPage";

export default function CaptureACHParticipantsFilters(props) {
    const globalContext = useBCMSContext() ?? {};
    BCMSRecord.globalControllerFor(Classes, globalContext);

    const ui = BCMSStateManagerCRUD.init(getDefaultUI())
        .update([ "showSearchChecked" ], true)
        .submit();

    return (
        <ParticipantsACHPage ui={ ui } />
    );
}